import {callGetApi} from "api/ApiCaller";
import {Get_Item_List_Item_GET} from "api/ApiConst";
import {API_SUCCESS} from "api/ResponseCodes";
import ModalWrapper from "components/common/ModalWrapper";
import React, {useEffect, useRef, useState} from "react";
import { useReactToPrint } from "react-to-print";
import { Print } from "utils/SvgComponent";
import { getImageSrcViaRefId } from "utils/UserUtils";
import {MODAL_LOADER} from "utils/constants";

const ViewPdf = ({recordID, showPdfModal, hideModal}) => {
    const [pdfData, setPdfData] = useState(null);
    useEffect(() => {
        if (recordID) {
            callGetApi(
                MODAL_LOADER,
                Get_Item_List_Item_GET.replace("{uuid}", recordID),
                {},
                (response) => {
                    if (response.errorCode === API_SUCCESS) {
                        const res = response.responsePacket;
                        setPdfData(res);
                    }
                }
            );
        }
    }, [recordID]);

    const contentToPrint = useRef();

        const handlePrint = useReactToPrint({
          content: () => contentToPrint.current,
        }); 

    return (
        <ModalWrapper show={showPdfModal} hide={() => hideModal()} size="xl" header={<div className="btn btn-primary rounded fd-6 px-3  " onClick={() => handlePrint()}><Print width="24" fill="white" /></div>}>
        {/* <div className="btn btn-primary rounded fd-6 px-3  " onClick={() => handlePrint()}><Print width="24" fill="white" /></div> */}
        <div id="pdf" ref={contentToPrint} className="text-start p-3 mx-auto">
            <img src="assets/images/logo-login.png" style={{width: "8%"}} />
            {/* <p className="m-0 fw-bold " style={{color: "#923100"}}>
                Cafe Lounge Bar
            </p> */}
            {/* <img src={Download_File_GET.replaceAll("{attachemntId}", "205ea4e9-31b3-431d-b87e-8720e797af18")} alt="" /> */}
            {pdfData && pdfData.itemImageRefIds && (
                <div className="row mt-3 justify-content-center">
                    <div className="col-lg-3 col-md-3 col-sm-6 col-5">
                        <img
                            className="img-fluid"
                            src={getImageSrcViaRefId(pdfData.itemImageRefIds[0])}
                            alt=""
                        />
                    </div>
                </div>
            )}
            <h5 className="m-0 mt-4 fw-bold" style={{fontSize: "30px"}}>
                {pdfData?.title}
            </h5>

            {pdfData && pdfData.ingredientDetailList.length > 0 && <div className="pdf-table-view table-responsive py-3">
                <table className="table table-bordered table-hover">
                    <thead className="thead-dark">
                        <tr>
                            <th scope="col">INGREDIENTS</th>
                            <th scope="col">UOM</th>
                            <th scope="col">QTY</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pdfData.ingredientDetailList.map((item, index) => (
                        <tr key={index}>
                            <td>{item.ingredientName}</td>
                            <td>{item.unitOfMeasurement}</td>
                            <td>{item.quantity}</td>
                        </tr>
                        ))}
                        
                    </tbody>
                </table>
            </div>}
            <div style={{textAlign: "left"}}>
                {pdfData && pdfData.cookingProcedures.length > 0 && <div>
                    <h6 className="heading-pdf">Cooking Procedure (stepwise)</h6>
                    <ul>
                        {pdfData.cookingProcedures.map((step, i) => (
                            <li key={i}>{step}</li>
                        ))}
                    </ul>
                </div>}
                <div className="row">
                    <div className="col-6">
                        {pdfData && pdfData.accompaniments.length > 0 && 
                        <div>
                            <h6 className="heading-pdf">Accompaniment</h6>
                            <ul>
                                {pdfData.accompaniments.map((item, i) => (
                                    <li key={i}>{item}</li>
                                ))}
                            </ul>
                        </div>
                        }
                        {pdfData && pdfData.garnishes.length > 0 && 
                        <div>
                            <h6 className="heading-pdf">Garnish</h6>
                            <ul>
                                {pdfData.garnishes.map((item, i) => (
                                    <li key={i}>{item}</li>
                                ))}
                            </ul>
                        </div>
                         }
                        {pdfData && pdfData.shelfLife?.length > 0 && (
                            <div>
                                <h6 className="heading-pdf">Shelf Life</h6>
                                <ul>
                                    {pdfData.shelfLife.map((item, i) => (
                                        <li key={i}>{item}</li>
                                    ))}
                                </ul>
                            </div>
                        )}
                        {pdfData && pdfData.warning?.length > 0 && (
                            <div>
                                <h6 className="heading-pdf">Warning</h6>
                                <ul>
                                    {pdfData.warning.map((item, i) => (
                                        <li key={i}>{item}</li>
                                    ))}
                                </ul>
                            </div>
                        )}
                       
                    </div>
                    {pdfData && (pdfData.itemDisposableImageRefId || pdfData.itemPlatewareImageRefId) && 
                    <div className="col-6">
                        <div className="pdf-table-view table-responsive py-3">
                            <table className="table table-bordered table-hover">
                                <thead className="thead-dark">
                                    <tr>
                                        {pdfData.itemPlatewareImageRefId && <th scope="col">PLATEWARE</th>}
                                        {pdfData.itemDisposableImageRefId && <th scope="col">DISPOSABLE</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        {pdfData.itemPlatewareImageRefId && <td>
                                            <img
                                                className="img-fluid"
                                                src={getImageSrcViaRefId(pdfData.itemPlatewareImageRefId)}
                                                alt=""
                                            />
                                        </td>}
                                        {pdfData.itemDisposableImageRefId && <td>
                                            <img
                                                className="img-fluid"
                                                src={getImageSrcViaRefId(pdfData.itemDisposableImageRefId)}
                                                alt=""
                                            />
                                        </td>}
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>}
                </div>
            </div>
        </div>
        </ModalWrapper>
    );
};

export default ViewPdf;
